const firebaseProps= ()=> {
 return  {
    apiKey: "AIzaSyAStqo8q_pWRXHmNn5V5M691_y3-PPAuY4",
    authDomain: "gnp-portalcorporativo-pro.firebaseapp.com",
    databaseURL: "https://gnp-portalcorporativo-pro.firebaseio.com",
    projectId: "gnp-portalcorporativo-pro",
    storageBucket: "gnp-portalcorporativo-pro.appspot.com",
    messagingSenderId: "787483551599"
    }
}


export default firebaseProps;


/*
QA
    {
        apiKey: "AIzaSyBT7YE-70GLv_qnKAEjAZCxMs49mNX6SlM",
        authDomain: "gnp-portalcorporativo-qa.firebaseapp.com",
        databaseURL: "https://gnp-portalcorporativo-qa.firebaseio.com",
        projectId: "gnp-portalcorporativo-qa",
        storageBucket: "",
        messagingSenderId: "430685090387"
    }
UAT
    {
        apiKey: "AIzaSyBbUVaOPSNN48FdR8ORmvLIJhZToGoJnLs",
        authDomain: "gnp-portalcorporativo-uat.firebaseapp.com",
        databaseURL: "https://gnp-portalcorporativo-uat.firebaseio.com",
        projectId: "gnp-portalcorporativo-uat",
        storageBucket: "gnp-portalcorporativo-uat.appspot.com",
        messagingSenderId: "787483551599"
    }
PRO
    {
        apiKey: "AIzaSyAStqo8q_pWRXHmNn5V5M691_y3-PPAuY4",
        authDomain: "gnp-portalcorporativo-pro.firebaseapp.com",
        databaseURL: "https://gnp-portalcorporativo-pro.firebaseio.com",
        projectId: "gnp-portalcorporativo-pro",
        storageBucket: "gnp-portalcorporativo-pro.appspot.com",
        messagingSenderId: "834427459956"
    }


*/



// WEBPACK FOOTER //
// ./src/properties/firebaseProps.js